import { populatedCampaignSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import * as z from "zod";

export const removeABTestVariant = {
  name: "removeABTestVariant" as const,
  input: z.object({ campaignId: z.string(), templateId: z.string() }),
  output: populatedCampaignSchema,
};
